import { useState, useEffect } from 'react';
import { useDebounce } from 'use-debounce';

/*
 * returns and object { showError, isValid, isEdited }
 *
 * showError is based on delayed validation and is false if the field the user has not yet edited the field
 *
 * e.g. if the minimum length of a field is 3 and the initial value is empty
 * - showError is initially false (no edits yet)
 * - if a user types a 5 letter word quite fast, showError won't be true during the typing
 *   (by default the there can be maximum 500 milliseconds between the keystrokes)
 * - but if the user types it more slowly, showError would be true when there are 1-2 characters in the field
 * - if the user would delete the field content, an empty content wouldn't pass the validator and showError would be true
 */

export const useValidation = (value: string, validator: (value: string) => boolean, delay = 500) => {
	const [ debouncedValue ] = useDebounce(value, delay);
	const [ editCount, setEditCount] = useState(-1);  // hook initialization will set the value to 0
	useEffect(() => {
		setEditCount(editCount + 1)
		// eslint-disable-next-line
	}, [debouncedValue]);
	const isEdited = (editCount > 0);
	return {
		showError: isEdited && !validator(debouncedValue),
		isValid: validator(value),
		isEdited
	};
}